import React from 'react';

/**
 * @param {{
 *  width: string | number,
 *  height: string | number,
 *  style?: React.CSSProperties
 * }} params
 */
const Loading = ({ width, height, style }) => (
  <div className="main-loading" style={style}>
    <div className="loader" style={{ width, height }} />
  </div>
);

export default Loading;
